import React, { useEffect, useState } from "react";

export function UpdateBotMetadataForm({
  showUpdateBotMetaData,
  setShowUpdateBotMetaData,
  bot,
  setBotListChanged,
}) {
  const [botToBeUpdated, setBotToBeUpdated] = useState();

  useEffect(() => {
    // console.log(`Inside use Effect UpdateBotMetaData ${JSON.stringify(bot)}`);
    setBotToBeUpdated(bot);
  }, [showUpdateBotMetaData]);

  if (showUpdateBotMetaData === false) {
    return "";
  }

  const ModalHeader =({name})=>{
      return (
        <h1 style={{ fontSize: "x-large", color: "black" }}>{name}</h1>
      )
  }

  const TextInput =({tname,tplaceholder,tvalue,tHandleOnChange})=>{
    return(
        <div style={{textAlign:'left'}}>
            <label for={tname} style={{fontSize:"12px"}}>{tname}</label> 
            <input
                type="text"
                className="ipc"
                placeholder={tplaceholder}
                name={tname}
                onChange={(e) => tHandleOnChange(e)}
                value={tvalue}
                required
                style={{marginTop:'6px',marginBottom:'10px'}}
                />  
        </div>
    )
  }

  const SelectInput =({sname,svalueList,svalue,onChangeHandler})=>{
      console.log(`SelectInput ${JSON.stringify(sname)} ${JSON.stringify(svalueList)}}`)
      return(
        <div style={{textAlign:'left'}}>
            <label for={sname} style={{fontSize:"12px"}}>{sname}</label>
            <select name={sname} className="ipc" value={svalue} onChange={e => onChangeHandler(e)}>
                {svalueList.map(v=>(
                    <option value={v.value}>{v.label}</option> 
                ))}
            </select>
        </div>
      )
  }

  const botStatusMap =[
      {value:"UNASSIGNED", label:"UNASSGINED"},
      {value:"ASSIGNED",  label:"ASSIGNED"},
      {value:"DESIGN",label:"DESIGN"},
      {value:"DEPLOYABLE", label:"DEPLOYABLE"}
  ]      

  function closeModal(){
      setShowUpdateBotMetaData(false);
  }
  const CancelButtonModal=({onClickHandler})=>{

    return(
        <button className="ips ipc" onClick={onClickHandler}>
            Cancel
        </button>
    )

  }

  const SubmitButtonModal=({sname})=>{
      return(
        <button type="submit" className="ips ipc">
           {sname}
      </button>
      )
  }

  function handleOnChange(e){
    let lbot = {...botToBeUpdated};

    if(e.target.name === "documentation"){
      lbot.documentation = e.target.value;
      
    }
   
    console.log("handleOnChange "+JSON.stringify(lbot));
    setBotToBeUpdated(lbot);
  }
  
  function onSubmit(e){

  }

  function onChangeBotStatus(e){
    console.log("onChangeBotStatus "+ e.target.value);
    let lbot = {...botToBeUpdated};
    lbot.botStatus = e.target.value;
    setBotToBeUpdated(lbot); 
  }

  return (
  
      <div className="modal">
        <div className="modal-content">
            <form onSubmit={onSubmit}>
                <ModalHeader name="Update Bot Metatdata"/>
                <TextInput disabled tname="Bot Name" tplaceholder="Enter BotName" tvalue={botToBeUpdated.botName} tHandleOnChange={handleOnChange}/>
                <TextInput tname="Bot Documentation" tplaceholder="Enter Documentation" tvalue={botToBeUpdated.documentation}/>
                {/* <SelectInput sname="Bot Status" svalueList={botStatusMap} svalue={botToBeUpdated.botStatus} onChangeHandler={onChangeBotStatus}/> */}
            </form>
       
            <div className="clearfix">
                <div className="row">
                <div className="col">
                    <CancelButtonModal onClickHandler={closeModal}/>
                </div>
                <div className="col">
                    <SubmitButtonModal sname="Update"/>
                </div>
                </div>
            </div>
        </div>
    </div>
    
  );
}
